import * as moment from 'moment';

export const DateFormatter = ({ date }) => {
    return <span className="text-muted">{date ? (moment(date).format("DD/MM/YYYY HH:mm:ss")) : "NC"}</span>;
}